import {createContext, useContext} from 'react';

export interface AuthUser {
  id: string;
  email: string;
  isInternal: boolean;
  fullName: string;
}

export type AuthTokens = {idToken: string; accessToken: string};

export interface AuthContextData {
  user: AuthUser | undefined;
  identityProvider: 'profiles' | 'auth0';
  iat?: number;
  logout: () => void;
  loginWithRedirect: () => Promise<void>;
  loginWithPopup: () => Promise<void>;
  loginSilently: () => Promise<void>;
  getTokens: () => Promise<AuthTokens>;
  isLoading: boolean;
}

export const AuthContext = createContext<AuthContextData | null>(null);

export function useAuth() {
  const authContext = useContext(AuthContext);
  if (!authContext) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return authContext;
}
